export type AddressComponentTypes =
| 'street_number' 
| 'route' 
| 'locality' 
| 'sublocality' 
| 'postal_code'
| 'country'
| 'administrative_area_level_1'
| 'administrative_area_level_2'

export type AddressComponent = {
  long_name: string
  short_name: string
  types: string[]
}

export type Geometry = {
  location: {
    lat: () => number
    lng: () => number
  }
}

type Location = {
  latitude: number
  longitude: number
}

export type PlaceData = {
  address1: string
  city: string
  zip: string
  county: string
  countryCode: string
  stateShort: string
  stateLong: string
  location?: Location
}

export const getAddressComponent = (addressComponents: AddressComponent[], type: AddressComponentTypes) => {
  return addressComponents.find(x => x.types.includes(type))
}

const getLongName = (addressComponents: AddressComponent[], type: AddressComponentTypes) => {
  return getAddressComponent(addressComponents, type)?.long_name ?? ''
}

const getShortName = (addressComponents: AddressComponent[], type: AddressComponentTypes) => {
  return getAddressComponent(addressComponents, type)?.short_name ?? ''
}

export const getPlaceData = (addressComponents: AddressComponent[], geometry?: Geometry): PlaceData => {
  const location = geometry ? { latitude: geometry.location.lat(), longitude: geometry.location.lng() } : undefined

  return {
    address1: (getLongName(addressComponents, 'street_number') + ' ' + getLongName(addressComponents, 'route')).trim(),
    city: getLongName(addressComponents, 'locality') || getLongName(addressComponents, 'sublocality'),
    zip: getShortName(addressComponents, 'postal_code'),
    county: getLongName(addressComponents, 'administrative_area_level_2'),
    countryCode: getShortName(addressComponents, 'country'),
    stateShort: getShortName(addressComponents, 'administrative_area_level_1'),
    stateLong: getLongName(addressComponents, 'administrative_area_level_1'),
    location
  }
}